module.exports = __webpack_public_path__ + "img/text.2d2cd8d3.png";